import HomeInsuranceValidations from '@/validations/home-insurance.json';
import { YEAR_CONSTRUCTED_INPUT_ATTRS } from '@/constants/inputs';

export default ({ store }) => {
  const validationList = [
    ...HomeInsuranceValidations.homeInsurance, YEAR_CONSTRUCTED_INPUT_ATTRS()
  ];
  store.commit('products/setValidations', validationList);
};
